import React, { Component } from 'react';
import firebase from 'firebase';
import Table from './Table';
import Modal from './Modal';
import Loader from './Loader';

// const booksRef = firebase.database().ref('/books');

class Books extends Component {
  constructor () {
    super();
    this.handleTitleChange = this.handleTitleChange.bind(this);
    this.handleEditBook = this.handleEditBook.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleModal = this.handleModal.bind(this);
    this.handleCloseModal = this.handleCloseModal.bind(this);
    this.handleClearSearch = this.handleClearSearch.bind(this);
    this.handleLoadMore= this.handleLoadMore.bind(this);
    this.booksRef = firebase.database().ref('/books');
    this.state = {
      books: [],
      filteredBooks: [],
      keywords: [],
      pageNumber: 1,
      nextKey: null,
      modal: null,
      max: 200
    }
  }


  /// MY REGEX IS BROKEN IN FIREFOX!!!
  searchBooks (title, author, keyword) {
    let newFilteredBooksArray;
    let titleReg = "(" + title + ")\\w*";

    let titleRegEx = new RegExp(titleReg, "ig");
    let authorRegEx = new RegExp("(" + author + ")\\w*", "gi");

    if (title && author) {
      newFilteredBooksArray = this.state.books.filter(book => {
        return typeof(book.Title) === 'string' && typeof(book.Author) === 'string' && book.Title.search(titleRegEx) > -1 && book.Author.search(authorRegEx) > -1;
      });
    } else if (title && !author) {
      newFilteredBooksArray = this.state.books.filter(book => {
        return typeof(book.Title) === 'string' && book.Title.search(titleRegEx) > -1;
      });
    } else if (!title && author) {
      newFilteredBooksArray = this.state.books.filter(book => {
        return typeof(book.Author) === 'string' && book.Author.search(authorRegEx) > -1;
      });
    }
    this.setState({
      filteredBooks: newFilteredBooksArray || []
    });
  }

  handleClearSearch (e) {
    if (e) {
      e.preventDefault();
    }
    this.refs.title.value = "";
    this.refs.author.value = "";
    this.setState({
      filteredBooks: []
    });
  }

  handleTitleChange (e) {
    this.searchBooks(this.refs.title.value, this.refs.author.value);
  }

  handleSubmit (e) {
    return e.preventDefault();
  }

  handleModal (book) {
    this.setState({
      modal: <Modal book={book} user={this.props.user} closeModal={this.handleCloseModal} clearSearch={this.handleClearSearch} editBook={this.handleEditBook}/>
    });
  }

  handleEditBook (book) {
    const self = this;
    const key = book.key;
    delete book.key;
    this.booksRef.child(key).set(book).then(() => {
      console.log('Book with id ' + key + ' has been updated!');
      self.setState({
        modal: null
      })
    }).catch(err => {
      console.log(err);
    });
  }

  handleCloseModal () {
    // e.preventDefault();
    this.setState({
      modal: null
    });
  }

  handleLoadMore (e) {
    e.preventDefault();
    let loadMore;
    if (this.state.books.length - this.state.max > 200 ) {
      loadMore = this.state.max + 200;
    } else {
      loadMore = this.state.books.length - 1;
    }

    this.setState({
      max: loadMore
    })
  }

  componentWillMount () {
    this.booksRef.on('value', (snapshot) => {
      let booksDB = [],
          keywords = [],
          sortedKeywords;
      snapshot.forEach(snap => {
        let book = snap.val();
        book.key = snap.key;
        booksDB.push(book);
        if (!book.Keywords) {
          book.Keywords = 0;
        }
        if (book.Keywords !== 0 && typeof(book.Keywords) !== 'string') {
          book.Keywords.forEach(k => {
            if ( keywords.indexOf(k) < 0 ) {
              keywords.push(k);
            }
          });
        }
      })
      sortedKeywords = keywords.sort((a,b) => {
        if (a < b) return -1;
        if (b < a) return 1;
        return 0;
      });
      this.setState({
        books: booksDB,
        keywords: sortedKeywords
      });
      console.log('finished loading data');
    });

    this.booksRef.on('child_changed', snapshot => {
      console.log('book with key ' + snapshot.key + ' has been updated');
    })

  }

  componentWillUnmount () {
    this.booksRef.off();
  }

  render() {
    let limitedBooks = this.state.books.filter((book, index) => {
      return index < this.state.max;
    });

    return (
      <div>
        {this.state.books.length < 1 ? (
          <Loader />
        ) : (
          <div className="col-xs-12">
            <div className="toast-container">
              <div className="alert alert-dismissible alert-success">
                <b>{this.state.books.length}</b> Books have loaded.
              </div>
            </div>
            <h1>Book Search</h1>
            <div className="">
              <form className="form form-horizontal" onSubmit={this.handleSubmit}>
                <div className="form-group">
                  <label className="col-md-3 control-label">Search By Title:</label>
                  <div className="col-md-9">
                    <input type="text" className="form-control" ref="title" defaultValue={this.state.searchTitle} onChange={this.handleTitleChange} placeholder="Search By Title" />
                  </div>
                </div>
                <div className="form-group">
                  <label className="col-md-3 control-label">Search By Author:</label>
                  <div className="col-md-9">
                    <input type="text" className="form-control" ref="author" onChange={this.handleTitleChange} placeholder="Search By Author"/>
                  </div>
                </div>
                <div className="form-group">
                  <div className="col-md-12">
                    <button className="btn btn-default pull-right" onClick={this.handleClearSearch}>Clear</button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        )}

        { this.state.filteredBooks.length > 0 ? (
          <div>
            <h2>Database Results - <span className="badge">{this.state.filteredBooks.length}</span></h2>
            {this.state.modal ? this.state.modal : null}
            <Table books={this.state.filteredBooks} handleModal={this.handleModal}/>
          </div>
        ) : null }
        { this.state.filteredBooks.length === 0 && this.state.books.length > 0 ? (
          <div>
            <h2>Database Results - <span className="badge">{this.state.books.length}</span></h2>
            {this.state.modal ? this.state.modal : null}
            <Table books={limitedBooks} handleModal={this.handleModal}/>
            <div className="text-center">
              <button className="btn btn-default" onClick={this.handleLoadMore}>Load More</button>
            </div>
          </div>
        ) : null }
      </div>
    );
  }
}

export default Books;



/** WEBPACK FOOTER **
 ** ./src/components/Books/Books.js
 **/